import { api } from './api'
import { throwApiError } from './apiHelpers'

function assertSuccess(body: unknown) {
  const b = body as { success?: boolean; message?: string; data?: unknown }
  if (!b?.success) {
    throw new Error(b?.message || 'Request failed')
  }
  return b.data
}

export type StoreSuspension = {
  id: number
  organisationId: number
  suspendedAt: string | null
  suspensionReason: string | null
}

/** Full-scope admins only: take a store offline. Shoppers see "temporarily unavailable"; the owner can still sign in. */
export async function suspendStore(storeId: string | number, reason?: string): Promise<StoreSuspension> {
  try {
    const { data } = await api.post(`/admin/stores/${encodeURIComponent(String(storeId))}/suspend`, {
      reason: reason?.trim() || undefined,
    })
    return assertSuccess(data) as StoreSuspension
  } catch (e) {
    throwApiError(e, 'Failed to suspend the store')
  }
}

/** Full-scope admins only: bring a suspended store back online. */
export async function reinstateStore(storeId: string | number): Promise<StoreSuspension> {
  try {
    const { data } = await api.post(`/admin/stores/${encodeURIComponent(String(storeId))}/reinstate`)
    return assertSuccess(data) as StoreSuspension
  } catch (e) {
    throwApiError(e, 'Failed to reinstate the store')
  }
}
